<template>
  <div id="project-one-theme-customer-view">
    <h2>ProjectOneThemeCustomerView.vue</h2>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#project-one-theme-customer-view {
  background-color: darkorange;
  color: white;
  height: 100%;
}
</style>
